import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { MessageTemplateForm } from "../../components/Customers/Templates/MessageTemplateForm";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { Page } from "../Page";

export const CreateMessageTemplatePage = () => {
    const history = useHistory();

    const handleClick = () => {
        history.push("/customers/messageTemplates");
    };

    return (
        <Page title="Create Template">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Customers</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Message Templates</Breadcrumb.Item>
                        <Breadcrumb.Item>Create Template</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    <MessageTemplateForm />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
